import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail
} from "@/components/ui/sidebar";
import nytecaIcon from "@/assets/nyteca-icon.svg";
import { useAuthStore } from "@/stores/auth.store";
import { Link, useLocation } from "@tanstack/react-router";
import { FileDown, FileText, ThumbsUp, Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SidebarUserMenu } from "./sidebar-user-menu";

export function AdminSidebar() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isAdmin = useAuthStore((s) => s.user?.role === "ADMIN");

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              size="lg"
              tooltip={t("common.appName")}
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <Link to="/chats">
                <img
                  src={nytecaIcon}
                  alt={t("common.appName")}
                  className="size-8 shrink-0"
                />
                <span className="truncate font-semibold">
                  {t("common.appName")}
                </span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>{t("admin.navigation")}</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  isActive={pathname === "/admin/prompt"}
                  tooltip={t("admin.prompt")}
                >
                  <Link to="/admin/prompt">
                    <FileText className="size-4" />
                    <span>{t("admin.prompt")}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  isActive={pathname === "/admin/word-export"}
                  tooltip={t("admin.wordExport")}
                >
                  <Link to="/admin/word-export">
                    <FileDown className="size-4" />
                    <span>{t("admin.wordExport")}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              {isAdmin && (
                <>
                  <SidebarMenuItem>
                    <SidebarMenuButton
                      asChild
                      isActive={pathname === "/admin/feedback"}
                      tooltip={t("admin.feedback")}
                    >
                      <Link to="/admin/feedback">
                        <ThumbsUp className="size-4" />
                        <span>{t("admin.feedback")}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                  <SidebarMenuItem>
                    <SidebarMenuButton
                      asChild
                      isActive={pathname === "/admin/users"}
                      tooltip={t("admin.users")}
                    >
                      <Link to="/admin/users">
                        <Users className="size-4" />
                        <span>{t("admin.users")}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                </>
              )}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter>
        <SidebarUserMenu />
      </SidebarFooter>

      <SidebarRail />
    </Sidebar>
  );
}
